import styled from "styled-components";
import { Field as FormikField } from "formik";

import { text, transition } from "@ui/helpers";

export const Field = styled(FormikField)`
  all: unset;

  ${text("regular_16")}

  position: relative;
  width: 100%;
  padding: ${({ theme }) =>
    `${theme.spacing.spacing_12} ${theme.spacing.spacing_16}`};
  border-radius: 8px;
  border: 1px solid ${props => props.theme.palette.grey200};
  background-color: ${props => props.theme.palette.white};
  transition: ${transition(["border-color"])};
  box-sizing: border-box;
  z-index: 1;
  cursor: initial;

  &:is(button) {
    cursor: pointer;
  }

  ${props => props.theme.breakpointsV2.smallTablet} {
    padding: ${props => props.theme.spacing.spacing_16};
  }

  ${props => props.theme.breakpointsV2.smallDesktop} {
    ${text("regular_18")}
  }

  &:hover {
    border-color: ${props => props.theme.palette.grey600};
  }

  &:has(svg) {
    display: grid;
    grid-template-columns: 1fr auto;
    gap: ${props => props.theme.spacing.spacing_8};
  }

  &::placeholder {
    color: currentColor;
  }
`;
